"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageTabs = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var copy_1 = require("../../copy");
var UsageTabs_styled_1 = require("./UsageTabs.styled");
/**
 * These are not actually conventional tabs, rather controls that affect the
 * single view that gets rendered - to prevent unnexcessary re-renders we use a
 * bespoke implimentation of the Nebula tabs.
 */
var UsageTabs = function (_a) {
    var children = _a.children, datePeriod = _a.datePeriod, setDatePeriod = _a.setDatePeriod, showTabs = _a.showTabs;
    var dispatch = (0, ui_tools_1.useAnalytics)().dispatch;
    var _b = (0, core_1.useComponents)(), TabList = _b.TabList, Tab = _b.Tab, TabPanel = _b.TabPanel, Card = _b.Card;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var tabs = [
        { name: 'yearly', title: copy('yearTabTitle') },
        { name: 'monthly', title: copy('monthTabTitle') },
        { name: 'daily', title: copy('dayTabTitle') },
    ];
    var current = tabs.findIndex(function (p) { return p.name === datePeriod; });
    var tabRefs = tabs.map(function () { return (0, react_1.createRef)(); });
    var _c = __read((0, react_1.useState)(), 2), focusedRef = _c[0], setFocusedRef = _c[1];
    var setActiveTab = function (selectedIndex) {
        var newPeriod = setDatePeriod(tabs[selectedIndex].name);
        // Cannot use AnalyticsClick as Tablist Children must be Tabs.
        dispatch({
            name: analytics_subjects_1.USAGE_TAB,
            type: 'click',
            properties: {
                value: newPeriod,
            },
        });
    };
    /**
     * onKeyDown and focusedRef behavior is copied from Nebula.
     */
    var onKeyDown = function (event) {
        if (event.key === 'ArrowLeft' && current > 0) {
            setActiveTab(current - 1);
            setFocusedRef(current - 1);
        }
        if (event.key === 'ArrowRight' && current < tabs.length - 1) {
            setActiveTab(current + 1);
            setFocusedRef(current + 1);
        }
    };
    (0, react_1.useEffect)(function () {
        if (focusedRef !== undefined) {
            var newFocus = tabRefs[focusedRef];
            newFocus && newFocus.current && newFocus.current.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focusedRef]);
    return showTabs ? (react_1.default.createElement(UsageTabs_styled_1.FakeTabs, { "data-testid": "usage-tabs", as: Card },
        react_1.default.createElement(TabList, { fullWidth: "always", tabIds: tabs.map(function (tab) { return tab.name; }), tabRefs: tabRefs, activeTab: current, onKeyDown: onKeyDown, setActiveTab: setActiveTab }, tabs.map(function (_a) {
            var title = _a.title, name = _a.name;
            return (react_1.default.createElement(Tab, { key: title, "data-testid": "tab-".concat(name) }, title));
        })),
        react_1.default.createElement(TabPanel, null, children))) : (react_1.default.createElement(Card, { "data-testid": "usage-card" }, children));
};
exports.UsageTabs = UsageTabs;
